const FormWidgetLovAssignmentConfig = {
  // 类型
  componentType: 'FORM_DATA_ASSIGNMENT',
  // 部件显示样式
  widgetConfig: {
    icon: 'form-lov',
    text: '数据赋值',
    optionTitle: true,
    description: '用于选择其他表单的数据字段'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 6, // 3, 6, 9, 12
    height: 1,
    render: {
      ide: 'FormWidgetLovAssignment',
      edit: 'FormWidgetLovAssignment',
      read: 'FormWidgetLovAssignment'
    },
    label: '数据赋值',

    inTable: true,
    methods: {
    },
    formAssignment: {}
  },
  editorConfig: [
    'INFO',
    'LABEL',
    'LOV_ASSIGNMENT',
    'WIDTH',
    'HIDDEN',
    'READONLY',
    'REQUIRED',
    'EDITONNEW',
    'UNIQUE'
  ],
  excludeEditorConfigInTable: ['WIDTH']
}

export default FormWidgetLovAssignmentConfig
